import { render, staticRenderFns } from "./service_agreement.vue?vue&type=template&id=1d9826ee&scoped=true&"
import script from "./service_agreement.vue?vue&type=script&lang=js&"
export * from "./service_agreement.vue?vue&type=script&lang=js&"
import style0 from "./service_agreement.vue?vue&type=style&index=0&id=1d9826ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9826ee",
  null
  
)

export default component.exports